module.exports = __webpack_public_path__ + "static/media/chevron-right.6a105c3d.svg";